import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import Slider from "./modules/site-nav";
Slider().init()

// Templates

// Template parts

// Pages
